// Empty functional component
const ThemeDecorations = () => null;
export default ThemeDecorations;
